export default [
    {
        path: "add-server",
        name: "addserver",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/serverList/AddServer.vue"
            ),
        meta: {
            title: `Add Server`,
        },
    },
    {
        path: "edit-server/:id",
        name: "editserver",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/serverList/EditServer.vue"
            ),
        meta: {
            title: `Edit Server`,
        },
    },
    {
        path: "server-lists",
        name: "serverlists",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/serverList/ServerLists.vue"
            ),
        meta: {
            title: `Servers`,
        },
    },
    {
        path: "/install-vpn-server/:id",
        name: "installovpns",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/serverList/InstallOvpn.vue"
            ),
        meta: {
            title: `Install or Repair Server`,
        },
    }
];
